import { CUSTOMER_PORTAL_GENERIC_CHANNEL_ID, FEEDBACK_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { sourceIconsComponentMap } from 'conversations-message-history/constants/sourceIcons';
import { MessagesIcon } from 'foundations-assets';
const fetchIconFromMap = genericChannelId => {
  if (!genericChannelId || genericChannelId === CUSTOMER_PORTAL_GENERIC_CHANNEL_ID || genericChannelId === FEEDBACK_GENERIC_CHANNEL_ID) {
    return undefined;
  }
  return sourceIconsComponentMap[genericChannelId];
};

/**
 * @description Given a genericChannelId resolve an icon to render for it. This
 * function also takes source to handle genericChannelId being null - when that
 * property can no longer be null we can remove source from this function.
 *
 * Icons here: https://tools.hubteamqa.com/trellis-design-docs/guidelines/design-elements/icons
 */

export const getIconForChannel = (genericChannelId, fallbackIcon = MessagesIcon) => {
  var _fetchIconFromMap;
  return (_fetchIconFromMap = fetchIconFromMap(genericChannelId)) !== null && _fetchIconFromMap !== void 0 ? _fetchIconFromMap : fallbackIcon;
};